import {CardMedia} from 'external/material'
import {staticAssetLink} from 'utils/url'

const coverImage = (course = 'default') => staticAssetLink('covers', `${course}.jpg`)

export default function CourseItem({course, courseName}) {
  return (
   <CardMedia
      component="img"
      image={coverImage(course)}
      onError={e => e.target.src = coverImage()}
      alt={courseName}
    />
  )
}

